var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFavoritActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.386 5h.23a4.529 4.529 0 0 1 3.277 1.542c1.548 1.757 1.45 4.493-.155 6.287l-.15.16-5.409 5.525c-.6.614-1.571.646-2.21.097l-.104-.097-5.547-5.667a4.637 4.637 0 0 1-1.316-3.365 4.63 4.63 0 0 1 1.492-3.29c1.747-1.607 4.496-1.504 6.276.162l.154.151.098.1.237-.242a4.531 4.531 0 0 1 2.684-1.33l.218-.022.225-.011Z",
  fill: "#F68A20",
  fillRule: "nonzero"
})));
export default SvgFavoritActive;